import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { Heading } from '../typography';

export type ProductPanelProps = {
  panelTitle: string;
};

const ProductPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductsContainer = styled.section`
  display: flex;
  gap: ${theme.spacings[5].rem};
  overflow-x: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  a {
    flex-shrink: 0;
    margin: ${theme.spacings[1].px};
  }
`;

const StyledHeading = styled(Heading)`
  font-size: 22px;
  line-height: 26px;
  margin-bottom: ${theme.spacings[4].px};
  color: ${theme.colors.tints.graysRed._2};
`;

export const ProductPanel = ({
  panelTitle,
  children,
}: PropsWithChildren<ProductPanelProps>): JSX.Element => {
  return (
    <ProductPanelContainer>
      <StyledHeading size={5}>{panelTitle}</StyledHeading>
      <ProductsContainer>{children}</ProductsContainer>
    </ProductPanelContainer>
  );
};
